/**
 * Same ordering rules as backend theme3 listing (admin tables).
 */

function hasExplicitDisplayOrder(doc) {
  if (!doc || doc.display_order === undefined || doc.display_order === null) {
    return false;
  }
  if (doc.display_order === "") return false;
  const n = Number(doc.display_order);
  return Number.isFinite(n);
}

function compareCreatedAtDesc(a, b) {
  const ca = new Date(a?.createdAt || 0).getTime();
  const cb = new Date(b?.createdAt || 0).getTime();
  return cb - ca;
}

function sortByDisplayOrderWithFallback(rows, fallbackCompare) {
  return [...(rows || [])].sort((a, b) => {
    const aE = hasExplicitDisplayOrder(a);
    const bE = hasExplicitDisplayOrder(b);
    if (aE && bE && Number(a.display_order) !== Number(b.display_order)) {
      return Number(a.display_order) - Number(b.display_order);
    }
    if (aE && !bE) return -1;
    if (!aE && bE) return 1;
    return fallbackCompare(a, b);
  });
}

function localDateKey(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

function eventDateKey(event) {
  const s = event?.event_date;
  if (!s) return null;
  if (typeof s === "string" && /^\d{4}-\d{2}-\d{2}/.test(s.trim())) {
    return s.trim().slice(0, 10);
  }
  const d = new Date(s);
  if (Number.isNaN(d.getTime())) return null;
  return localDateKey(d);
}

function compareEventsByDateThenTime(a, b) {
  const ka = eventDateKey(a);
  const kb = eventDateKey(b);
  if (!ka && !kb) return compareCreatedAtDesc(a, b);
  if (!ka) return 1;
  if (!kb) return -1;
  const c = ka.localeCompare(kb);
  if (c !== 0) return c;
  return String(a?.event_start_time || "").localeCompare(
    String(b?.event_start_time || "")
  );
}

export function sortBlogsJobsNewsForAdmin(rows) {
  return sortByDisplayOrderWithFallback(rows, compareCreatedAtDesc);
}

export function sortEventsForAdmin(rows) {
  return sortByDisplayOrderWithFallback(rows, compareEventsByDateThenTime);
}
